import React from 'react';
import {Menu, Dropdown} from '@enos/dpl';
import {observer} from 'mobx-react';
import {getLocale, setLocaleToCookie} from '@locale';
// import {LAN_ENGLISH, LAN_CHINESE, LAN_CHINESE_KEY, LAN_ENGLISH_KEY} from '~/utils/constants';
import {switchLocale, formatLanToText} from '~/utils/tools';
import './index.less';

@observer
class LocaleSwitcher extends React.Component {
  currentLan = () => {
    const {sessionStore} = this.props;
    const lan = sessionStore.languagesConfig.includes(getLocale()) ? getLocale() : sessionStore.languagesConfig[0];
    if (lan) {
      setLocaleToCookie(lan, document.location.protocol.split(':')[0] === 'https' && {
        Secure: true,
        SameSite: 'None'
      });
    }
    return lan;
  }


  render() {
    const {sessionStore} = this.props;
    const menu = (
      <Menu className='lan-list'>
        {sessionStore.languagesConfig.map(i => (
          <Menu.Item
            {...{[['key'][0]]: i}}
            onClick={() => { switchLocale(i); }}
            className={i === this.currentLan() ? 'app-portal-current-lan' : ''}
          >
            {formatLanToText(i)}
          </Menu.Item>
        )
        )}
      </Menu>
    );

    return (
      <Dropdown overlay={menu} trigger={['click']}>
        <div className='locale-switcher sub'>
          <span className='current-lan'>{formatLanToText(this.currentLan())}</span>
          <i className='dpl20_caret_down_s' />
        </div>
      </Dropdown>
    );
  }
}

export default LocaleSwitcher;
